<script>
	export let data;
	export let categories;
	export let blocks;
	export let selectBlock;  
	export let deselectBlock;

	function toggleItem(id) {
		if (!blocks[id].active) {
			selectBlock(id)
		} else {
			deselectBlock(id)
		}
	}
</script>


{#each categories as category}	
	<div class="heading">{category}</div>

	{#each data as item}
		{#if item.category == category}	
			<div 	class="block" 
					class:active={blocks[item.id]['active']}
					class:highlight={blocks[item.id]['highlight']}
					bind:this={blocks[item.id]['elem']}>
				<div class="head" on:click={toggleItem(item.id)}>
					<h2>{item.question}</h2>
					<div class="more"><div></div></div>
				</div>
				<p class="content">
					{item.answer}
				</p>
			</div>
		{/if}
	{/each}
{/each}





<style lang="scss">
	@import "../main.scss";
	.heading {
		font-family: $ff-serif;
		font-weight: 700;
		font-size: 32px;
    line-height: 140%;
    width: calc(100% - 20px);
		max-width: 620px;
		margin: 60px auto 20px auto;
	}
	.block {
		border-top: 1px solid #E4E4E4;
    width: calc(100% - 20px);
		max-width: 620px;
    margin: 0 auto;
    position: relative;

		.head {
			display: flex;
			padding: 10px 0;
			cursor: pointer;

			h2 {
				flex-grow: 1;
				margin: 0;
				font-family: $ff-serif;
				font-weight: 700;
				font-size: 20px;
				line-height: 30px;
        padding-right: 6px;
        max-width: 100%;

				@media (max-width: $breakpoint-mobile-l) {
					font-size: 18px;
				}

			}

			.more {
				position: relative;
				width: 16px;
				height: 16px;
				flex-shrink: 0;
				align-self: center;
				padding-left: 6px;

				div {
					display: inline-block;
					width: 10px;
					height: 10px;
					position: absolute;
					top: 0;
					left: 6px;
					cursor: pointer;
					transform-origin: center center;
					border-right: 2px solid #000;
					border-bottom: 2px solid #000;
					transform: rotate(45deg);
					transition: transform 0.1s;
					transition-timing-function: cubic-bezier(.27,.09,.28,1.01);
				}
				
			}
		}

		.content {
			display: none;
			font-family: $ff-sans;
			font-weight: 400;
			font-size: 18px;
			line-height: 27px;
      margin: 0 0 40px 0;
      width: 100%;

      p {
        max-width: 100%;
      }
		}

		&.active {
			.head {
				.more {
					div {
					  transform: rotate(225deg);
						border-right: 2px solid #c90c0f;
						border-bottom: 2px solid #c90c0f;
					}
				}
			}
			.content {
				display: block;
			}
		}
  }

  .highlight::before {
    content: ' ';
    position: absolute;
    top: -1px;
    left: -20px;
    right: -20px;
    bottom: -41px;
    background: transparent;
    animation: flash 1.3s forwards;
    border-top: 1px solid #2a2a2a;
    border-bottom: 1px solid #e4e4e4;
    pointer-events: none;

    @media (max-width: 650px) {
      left: -10px;
      right: -10px;
    }
  }
  
  @keyframes flash {
    0% {background: rgba(0, 0, 0, 0)}
    15% {background: rgba(0, 0, 0, 0.17)}
    100% {background: rgba(0, 0, 0, 0.05)}
  }
</style>
